import React from "react";
import { AddCircleOutline, Cancel } from "@mui/icons-material";
import { CurrencyInputField, InputField } from "components/form";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { QuoteAftermarketProductType } from "@trnsact/trnsact-shared-types";
import { Box, Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { TotalSumOfSection } from "./TotalSumOfSection";
import { QuoteArrayFieldsProps, QuoteFormValues } from "../../../types";
import { formatSnakeToCamelCaseLabel } from "../../../../../utils/formatters";

export const AftermarketProductsSection = ({ equipmentId = null }: QuoteArrayFieldsProps) => {
  const { control, getValues } = useFormContext<QuoteFormValues>();
  const { fields, append, remove } = useFieldArray({ control, name: "aftermarketProducts" });
  const aftermarketProducts = useWatch({ control, name: "aftermarketProducts" });

  const handleAddCustomFee = () => {
    append({ cost: 0, equipmentId, description: "", type: QuoteAftermarketProductType.Other });
  };

  return (
    <Box className="quoteSection">
      <Typography variant="h6" component="span">
        Aftermarket Products
      </Typography>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "1rem" }}>
        {fields.map(({ id }, index) => (
          <>
            {getValues(`aftermarketProducts.${index}.type`) !== QuoteAftermarketProductType.Other ? (
              <CurrencyInputField
                control={control}
                name={`aftermarketProducts.${index}.cost`}
                label={formatSnakeToCamelCaseLabel(getValues(`aftermarketProducts.${index}.type`))}
              />
            ) : (
              <Box sx={{ gridColumn: "1 / -1" }}>
                <Box key={id} className="arrField">
                  <Stack direction="row" alignItems="center">
                    <Typography>Aftermarket Product</Typography>

                    {getValues(`aftermarketProducts.${index}.type`) === QuoteAftermarketProductType.Other && (
                      <Tooltip title="Remove Aftermarket Product">
                        <IconButton size="small" onClick={() => remove(index)}>
                          <Cancel color="error" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Stack>

                  <Box className="quoteFields">
                    <InputField
                      label="Type"
                      control={control}
                      name={`aftermarketProducts.${index}.type`}
                      inputProps={{ disabled: true }}
                    />

                    <CurrencyInputField label="Cost" control={control} name={`aftermarketProducts.${index}.cost`} />

                    <InputField
                      control={control}
                      label="Description"
                      name={`aftermarketProducts.${index}.description`}
                      inputProps={{ placeholder: "Enter description ..." }}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </>
        ))}
      </Box>

      <Stack direction="row" gap="1rem" justifyContent="space-between" alignItems="center">
        <Button size="small" startIcon={<AddCircleOutline />} onClick={handleAddCustomFee}>
          Add
        </Button>

        <TotalSumOfSection values={aftermarketProducts} calcKey="cost" />
      </Stack>
    </Box>
  );
};
